import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { SqlMISink } from 'app/model/pipeline/copysink/sql-mi.copysink';
import { sqlSinkAdapts, SqlSinkAdapter } from './sql.sink.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SqlMISink),
    asynchronous: true,
    adapts: sqlSinkAdapts
})
export class SqlMISinkAdapter extends SqlSinkAdapter {}
